import { ADIFParserService } from "./adif-parser.service";
import { qsoRepository } from "@/db/repositories/qso.repository";
import { QSO } from "@/types/qso.types";

export interface QSOImportResult {
  qsos: QSO[];
  duplicateCount: number;
}

export class QSOADIFImportService {
  private parser = new ADIFParserService();

  async importADIF(
    file: File
  ): Promise<QSOImportResult> {
    const content = await file.text();
    
    const qsoRecords = this.parser.parseADIFToQSORecords(content);
    
    let duplicateCount = 0;
    const importedQsos: QSO[] = [];
    
    // 检查重复记录
    const existingQsos = await qsoRepository.findAll();
    const existingIds = new Set(existingQsos.map(qso => qso.id));
    
    for (const qsoRecord of qsoRecords) {
      if (existingIds.has(qsoRecord.id)) {
        // 重复记录，跳过
        duplicateCount++;
        continue;
      }
      
      importedQsos.push(qsoRecord);
    }
    
    // 批量导入新记录
    if (importedQsos.length > 0) {
      await qsoRepository.bulkCreate(importedQsos);
    }
    
    return {
      qsos: importedQsos,
      duplicateCount
    };
  }
}